import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { LoggerService } from 'src/shared/logger/logger.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Levels } from 'src/shared/logger/levels.enum';
import { SystemProfileService } from 'src/system-profile-manager/shared/system-profile-V2.service';
import { endpoint } from 'src/system-profile-manager/shared/endpoints.model';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import jwt_decode from 'jwt-decode'

@Component({
  templateUrl: './addNote.dialog.component.html',
  styleUrls: ['./addNote.dialog.component.css'],
  providers: [SystemProfileService]
})
export class AddNoteComponent {
  insertedNoteText: string;
  endpoint_data: endpoint;
  user_info_obj: any;
  @ViewChild('f') insertForm: NgForm;

  constructor(private loggerService: LoggerService,
    private systemService: SystemProfileService,
    private _snackBar: MatSnackBar, @Inject(MAT_DIALOG_DATA) public dataReceived: endpoint,
    public dialogRef: MatDialogRef<AddNoteComponent>) {
  }

  ngOnInit(): void {
    this.user_info_obj = jwt_decode(localStorage.getItem('accessToken'));

    if (!this.dataReceived.ops_note) this.dataReceived.ops_note = "";
    this.endpoint_data = this.dataReceived;
    const [first, ...rest] = this.dataReceived.ops_note.split(':-');
    this.insertedNoteText = rest.join(":-");
    this.systemService.endpointDateToBeTransmitted.subscribe(data => {
      if (data) {
        if (!data.ops_note) data.ops_note = "";
        this.endpoint_data = data;
        this.insertedNoteText = data.ops_note
      }
    });
  }

  onSubmitTextArea() {
    if (this.insertForm.valid) {
      this.systemService.addNoteToSystem(this.endpoint_data.system_ip, this.insertedNoteText, this.user_info_obj.name).subscribe(data => {
        data["message"];
        this.dialogRef.close(data["message"]);
      }, err => {
        this.loggerService.log("AddNoteComponent", err.message, Levels.error)
        this.openSnackBar('Connection error occurred try again later', "Error");
        this.dialogRef.close();
      })
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    this.dialogRef.close();
  }

}
